import { cfgHasSports, toTileCdn } from '@infinitro/config';
export const sportsTurboslots = cfgHasSports()
    ? [
        {
            game: 'soccer-1',
            prov: 'Sports',
            tile: toTileCdn(`sports/soccer.png`)
        },
        {
            game: 'rugby-union-12',
            prov: 'Sports',
            tile: toTileCdn(`sports/rugby.png`)
        },
        {
            game: 'basketball-2',
            prov: 'Sports',
            tile: toTileCdn(`sports/basketball.png`)
        },
        {
            game: 'baseball-3',
            prov: 'Sports',
            tile: toTileCdn(`sports/baseball.png`)
        },
        {
            game: 'oil-wrestling',
            prov: 'Sports',
            tile: toTileCdn(`sports/oil_wrestling.png`)
        },
        {
            game: 'volleyball-23',
            prov: 'Sports',
            tile: toTileCdn(`sports/volleyball.png`)
        },
        {
            game: 'wrestling',
            prov: 'Sports',
            tile: toTileCdn(`sports/wrestling.png`)
        }
    ]
    : [];
